// vendor
import { computed, Ref, ComputedRef } from "@vue/composition-api";

type RT<T> = Ref<T>|ComputedRef<T>;
type PropFn<T> = (v:T) => number;

export const useListSort = <T>(list:RT<T[]>, asc:RT<boolean>, prop:PropFn<T>) => {

	const sorted = computed(() => {
		const v = [ ...list.value ];
		v.sort(sort);
		return v;
	});
	
	const sort = (a:T, b:T) => {
		return asc.value ? prop(a) - prop(b) : prop(b) - prop(a)
	};

	return {
		sorted,
	};

};